<!-- ======== NAVBAR ======== -->
<nav class="landing-nav" id="top" [class.nav-open]="mobileNavOpen">
  <div class="nav-container">
    <!-- Logo (left) -->
    <a class="nav-brand" routerLink="/home" (click)="closeMobileNav()">
      <img [src]="logoSrc" alt="GardeKids" class="brand-logo-img" />
    </a>

    <button
      type="button"
      class="nav-burger"
      (click)="toggleMobileNav()"
      [attr.aria-expanded]="mobileNavOpen"
      aria-controls="landing-nav-panel"
      aria-label="Menu"
    >
      <mat-icon>{{ mobileNavOpen ? 'close' : 'menu' }}</mat-icon>
    </button>

    <!-- Nav links + actions (right) -->
    <div class="nav-right" id="landing-nav-panel" [class.is-open]="mobileNavOpen">
      <a class="nav-link" (click)="scrollTo('features')">{{ 'LANDING.NAV.FEATURES' | translate }}</a>
      <a class="nav-link" (click)="scrollTo('solutions')">{{ 'LANDING.NAV.SOLUTIONS' | translate }}</a>
      <a class="nav-link" (click)="scrollTo('how-it-works')">{{ 'LANDING.NAV.HOW_IT_WORKS' | translate }}</a>
      <a class="nav-link" (click)="scrollTo('our-schools')">{{ 'LANDING.NAV.DIRECTORY' | translate }}</a>
      <a class="nav-link" (click)="scrollTo('school-signup')">{{ 'LANDING.NAV.SCHOOLS' | translate }}</a>
      <a class="nav-link" (click)="scrollTo('cta')">{{ 'LANDING.NAV.PRICING_DEMO' | translate }}</a>
      <a class="nav-link" (click)="scrollTo('cta')">{{ 'LANDING.NAV.CONTACT' | translate }}</a>

      <!-- Language switcher (compact) -->
      <button mat-icon-button [matMenuTriggerFor]="langMenu" class="btn-lang">
        <img [src]="currentFlag" height="20" alt="Language">
      </button>
      <mat-menu #langMenu="matMenu">
        @for (item of listLang; track item.lang) {
          <button mat-menu-item (click)="setLanguage(item)" [class.active]="currentLang === item.lang">
            <img [src]="item.flag" height="16" class="lang-flag"> <span>{{ item.text }}</span>
          </button>
        }
      </mat-menu>

      <a class="nav-link nav-link-login" routerLink="/authentication/signin" (click)="closeMobileNav()">
        {{ 'LANDING.NAV.LOGIN' | translate }}
      </a>
      <a class="btn-subscribe-pill" routerLink="/inscription" (click)="closeMobileNav()">
        &rarr; {{ 'LANDING.NAV.SUBSCRIBE' | translate }}
      </a>
    </div>
  </div>
</nav>

<!-- ======== HERO ======== -->
<section class="hero" id="hero">
  <div class="hero-content">
    <h1 class="hero-title">
      {{ 'LANDING.HERO.TITLE_1' | translate }}
      <span class="text-green">{{ 'LANDING.HERO.TITLE_HIGHLIGHT' | translate }}</span>
      {{ 'LANDING.HERO.TITLE_2' | translate }}
    </h1>
    <p class="hero-subtitle">
      {{ 'LANDING.HERO.SUBTITLE' | translate }}
    </p>
    <div class="hero-buttons">
      <a class="btn-enroll" routerLink="/inscription">
        <img src="assets/images/home/fluent-mdl2_open-enrollment%20(1).png" alt="" class="btn-icon" />
        {{ 'LANDING.HERO.CTA_SUBSCRIBE' | translate }}
      </a>
      <a class="btn-access" (click)="scrollTo('cta')">
        {{ 'LANDING.HERO.CTA_DEMO' | translate }}
      </a>
    </div>
  </div>
</section>

<!-- ======== FEATURES BANNER ======== -->
<section class="features-banner" id="features">
  <div class="banner-line-left"></div>
  <h2 class="features-title">{{ 'LANDING.FEATURES.TAG' | translate }}</h2>
  <div class="banner-line-right"></div>
</section>

<!-- ======== EVERYTHING YOU NEED ======== -->
<section class="everything-section" id="solutions">
  <div class="everything-container">
    <h2 class="everything-title">{{ 'LANDING.FEATURES.TITLE' | translate }}</h2>
    <p class="everything-subtitle">{{ 'LANDING.FEATURES.SUBTITLE' | translate }}</p>
    <div class="everything-grid">
      <div class="everything-card">
        <img src="assets/images/home/image 5.jpg" alt="Feature 1" loading="lazy" />
      </div>
      <div class="everything-card">
        <img src="assets/images/home/image 6.jpg" alt="Feature 2" loading="lazy" />
      </div>
      <div class="everything-card">
        <img src="assets/images/home/image 7.jpg" alt="Feature 3" loading="lazy" />
      </div>
      <div class="everything-card">
        <img src="assets/images/home/image 8.jpg" alt="Feature 4" loading="lazy" />
      </div>
    </div>
  </div>
</section>

<!-- ======== FEATURE HIGHLIGHTS ======== -->
<section class="feature-highlights">
  <div class="feature-highlights-container">
    <div class="feature-row">
      <div class="feature-text">
        <h3>{{ 'LANDING.FEATURES.MANAGE_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.FEATURES.MANAGE_DESC' | translate }}</p>
      </div>
      <div class="feature-image">
        <img src="assets/images/home/image 10.jpg" alt="School Management" loading="lazy" />
      </div>
    </div>
    <div class="feature-row feature-row-reverse">
      <div class="feature-text">
        <h3>{{ 'LANDING.FEATURES.PARENTS_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.FEATURES.PARENTS_DESC' | translate }}</p>
      </div>
      <div class="feature-image">
        <img src="assets/images/home/image 11.jpg" alt="Parent Portal" loading="lazy" />
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-text">
        <h3>{{ 'LANDING.FEATURES.CALENDAR_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.FEATURES.CALENDAR_DESC' | translate }}</p>
      </div>
      <div class="feature-image">
        <img src="assets/images/home/image 14.jpg" alt="Smart Calendar" loading="lazy" />
      </div>
    </div>
    <div class="feature-row feature-row-reverse">
      <div class="feature-text">
        <h3>{{ 'LANDING.FEATURES.TEACHERS_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.FEATURES.TEACHERS_DESC' | translate }}</p>
      </div>
      <div class="feature-image">
        <img src="assets/images/home/image 15.jpg" alt="Teacher Area" loading="lazy" />
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-text">
        <h3>{{ 'LANDING.FEATURES.SECURITY_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.FEATURES.SECURITY_DESC' | translate }}</p>
      </div>
      <div class="feature-image">
        <img src="assets/images/home/image 16.jpg" alt="Data Security" loading="lazy" />
      </div>
    </div>
  </div>
</section>

<!-- ======== HOW IT WORKS BANNER ======== -->
<section class="features-banner" id="how-it-works">
  <div class="banner-line-left"></div>
  <h2 class="features-title">{{ 'LANDING.STEPS.TAG' | translate }}</h2>
  <div class="banner-line-right"></div>
</section>

<!-- ======== 4 EASY STEPS ======== -->
<section class="easy-steps">
  <div class="easy-steps-container">
    <h2 class="easy-steps-title">{{ 'LANDING.STEPS.TITLE' | translate }}</h2>
    <p class="easy-steps-subtitle">{{ 'LANDING.STEPS.SUBTITLE' | translate }}</p>
    <div class="easy-steps-grid">
      <div class="step-card">
        <div class="step-icon">
          <img src="assets/images/home/Vector.png" alt="Find" />
        </div>
        <h3>{{ 'LANDING.STEPS.SEARCH_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.STEPS.SEARCH_DESC' | translate }}</p>
      </div>
      <div class="step-card">
        <div class="step-icon">
          <img src="assets/images/home/fluent-mdl2_open-enrollment.png" alt="Register" />
        </div>
        <h3>{{ 'LANDING.STEPS.REGISTER_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.STEPS.REGISTER_DESC' | translate }}</p>
      </div>
      <div class="step-card">
        <div class="step-icon">
          <img src="assets/images/home/game-icons_confirmed.png" alt="Confirmed" />
        </div>
        <h3>{{ 'LANDING.STEPS.CONFIRM_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.STEPS.CONFIRM_DESC' | translate }}</p>
      </div>
      <div class="step-card">
        <div class="step-icon">
          <img src="assets/images/home/mdi_learn-outline.png" alt="Learn" />
        </div>
        <h3>{{ 'LANDING.STEPS.START_TITLE' | translate }}</h3>
        <p>{{ 'LANDING.STEPS.START_DESC' | translate }}</p>
      </div>
    </div>
    <div class="easy-steps-cta">
      <a class="btn-start-enrollment" routerLink="/inscription">&rarr; {{ 'LANDING.STEPS.CTA' | translate }}</a>
    </div>
  </div>
</section>

<!-- ======== READY CTA ======== -->
<section class="ready-cta" id="cta">
  <div class="ready-cta-container">
    <img [src]="logoSrc" alt="GardeKids" class="ready-cta-logo" />
    <h2 class="ready-cta-title">{{ 'LANDING.CTA.TITLE' | translate }}</h2>
    <p class="ready-cta-subtitle">{{ 'LANDING.CTA.SUBTITLE' | translate }}</p>
    <div class="ready-cta-buttons">
      <a class="btn-enroll-cta" routerLink="/inscription">
        <img src="assets/images/home/fluent-mdl2_open-enrollment.png" alt="" class="btn-cta-icon" />
        {{ 'LANDING.HERO.CTA_SUBSCRIBE' | translate }}
      </a>
      <a class="btn-access-cta" (click)="scrollTo('school-signup')">
        {{ 'LANDING.HERO.CTA_DEMO' | translate }}
      </a>
    </div>
  </div>
</section>

<!-- ======== IMAGE GALLERY ======== -->
<section class="image-gallery">
  <div class="image-gallery-row">
    <div class="image-gallery-item"><img src="assets/images/home/image 18.jpg" alt="" loading="lazy" /></div>
    <div class="image-gallery-item"><img src="assets/images/home/image 19.jpg" alt="" loading="lazy" /></div>
    <div class="image-gallery-item"><img src="assets/images/home/image 20.jpg" alt="" loading="lazy" /></div>
    <div class="image-gallery-item"><img src="assets/images/home/image 21.jpg" alt="" loading="lazy" /></div>
  </div>
</section>

<!-- ======== TEMOIGNAGES ======== -->
<section class="testimonials-section" id="testimonials">
  <div class="testimonials-container">
    <h2 class="testimonials-title">Ils nous font confiance</h2>
    <p class="testimonials-subtitle">Retours d’établissements qui utilisent GardKids au quotidien</p>
    <div class="testimonials-grid">
      <blockquote class="testimonial-card">
        <p>« Une plateforme claire qui rapproche enfin les parents et l’équipe éducative. »</p>
        <footer>— Directrice, jardin d’enfants</footer>
      </blockquote>
      <blockquote class="testimonial-card">
        <p>« Suivi des présences et des journaux simplifié pour toute l’équipe. »</p>
        <footer>— Coordinatrice pédagogique</footer>
      </blockquote>
      <blockquote class="testimonial-card">
        <p>« L’inscription en ligne a réduit nos allers-retours administratifs. »</p>
        <footer>— Responsable administrative</footer>
      </blockquote>
    </div>
  </div>
</section>

<!-- ======== AVAILABLE SCHOOLS ======== -->
<section class="our-schools-section" id="our-schools">
  <div class="our-schools-container">
    <h2 class="our-schools-title">
      Annuaire des établissements
      @if (!loadingSchools && registeredSchools.length > 0) {
        <span class="schools-count-badge">{{ registeredSchools.length }}</span>
      }
    </h2>
    <p class="our-schools-subtitle">{{ 'LANDING.SCHOOLS.SUBTITLE' | translate }}</p>
    @if (loadingSchools) {
      <div class="no-schools">
        <mat-icon>school</mat-icon>
        <p>{{ 'LANDING.SCHOOLS.LOADING' | translate }}</p>
      </div>
    } @else if (registeredSchools.length === 0) {
      <div class="no-schools">
        <mat-icon>school</mat-icon>
        <p>{{ 'LANDING.SCHOOLS.NONE' | translate }}</p>
      </div>
    } @else {
      <div class="schools-coverflow">
        <button class="coverflow-btn coverflow-prev" (click)="prevSchool()">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <div class="coverflow-stage">
          @for (school of registeredSchools; track school.id; let i = $index) {
            <div class="coverflow-card"
              [class.active]="i === activeSchoolIndex"
              [class.prev-1]="getCardPosition(i) === -1"
              [class.prev-2]="getCardPosition(i) === -2"
              [class.next-1]="getCardPosition(i) === 1"
              [class.next-2]="getCardPosition(i) === 2"
              [class.hidden-card]="Math.abs(getCardPosition(i)) > 2"
              (click)="goToSchool(i)">
              <div class="school-client-card">
                <div class="school-client-logo">
                  <img [src]="school.logo || 'assets/images/banner/1.png'" [alt]="school.school_name"
                    onerror="this.src='assets/images/banner/1.png'" />
                </div>
                <div class="school-client-info">
                  <h3 class="school-client-name">{{ school.school_name }}</h3>
                  <span class="school-client-type">{{ school.type }}</span>
                  @if (school.description) {
                    <p class="school-client-desc">{{ school.description }}</p>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        <button class="coverflow-btn coverflow-next" (click)="nextSchool()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <!-- Dots -->
      <div class="carousel-dots">
        @for (school of registeredSchools; track school.id; let i = $index) {
          <button class="carousel-dot" [class.active]="i === activeSchoolIndex" (click)="goToSchool(i)"></button>
        }
      </div>
    }
  </div>
</section>

<!-- ======== SCHOOL SIGNUP (établissements) ======== -->
<section class="school-signup-section" id="school-signup">
  <div class="school-signup-container">
    <h2 class="school-signup-title">{{ 'LANDING.SCHOOL_SIGNUP.TITLE' | translate }}</h2>
    <p class="school-signup-subtitle">{{ 'LANDING.SCHOOL_SIGNUP.SUBTITLE' | translate }}</p>

    @if (schoolSignupSent) {
      <div class="school-signup-success">
        <mat-icon>check_circle</mat-icon>
        <p>{{ 'LANDING.SCHOOL_SIGNUP.SUCCESS' | translate }}</p>
      </div>
    } @else {
      <form class="school-signup-form" (ngSubmit)="submitSchoolSignup()" #schoolForm="ngForm">
        <div class="school-signup-grid">
          <label class="school-field">
            <span>{{ 'LANDING.SCHOOL_SIGNUP.SCHOOL_NAME' | translate }}</span>
            <input name="schoolName" [(ngModel)]="schoolSignup.schoolName" required />
          </label>
          <label class="school-field">
            <span>{{ 'LANDING.SCHOOL_SIGNUP.TYPE' | translate }}</span>
            <select name="schoolType" [(ngModel)]="schoolSignup.type" required>
              <option value="">{{ 'LANDING.SCHOOL_SIGNUP.TYPE_PLACEHOLDER' | translate }}</option>
              <option value="Garderie">Garderie</option>
              <option value="Crèche">Crèche</option>
              <option value="École maternelle">École maternelle</option>
              <option value="Autre">Autre</option>
            </select>
          </label>
          <label class="school-field">
            <span>{{ 'LANDING.SCHOOL_SIGNUP.CITY' | translate }}</span>
            <input name="city" [(ngModel)]="schoolSignup.city" required />
          </label>
          <label class="school-field">
            <span>{{ 'LANDING.SCHOOL_SIGNUP.CONTACT' | translate }}</span>
            <input name="contactName" [(ngModel)]="schoolSignup.contactName" required />
          </label>
          <label class="school-field">
            <span>{{ 'LANDING.SCHOOL_SIGNUP.EMAIL' | translate }}</span>
            <input name="email" type="email" [(ngModel)]="schoolSignup.email" required />
          </label>
          <label class="school-field">
            <span>{{ 'LANDING.SCHOOL_SIGNUP.PHONE' | translate }}</span>
            <input name="phone" [(ngModel)]="schoolSignup.phone" required />
          </label>
        </div>
        <label class="school-field school-field-full">
          <span>{{ 'LANDING.SCHOOL_SIGNUP.MESSAGE' | translate }}</span>
          <textarea name="message" rows="3" [(ngModel)]="schoolSignup.message"></textarea>
        </label>
        <button class="btn-school-signup" type="submit" [disabled]="schoolForm.invalid || schoolSignupSending">
          {{ 'LANDING.SCHOOL_SIGNUP.SUBMIT' | translate }}
        </button>
      </form>
    }
  </div>
</section>

<!-- ======== FOOTER ======== -->
<footer class="landing-footer">
  <div class="footer-container">
    <div class="footer-main">
      <div class="footer-brand">
        <div class="footer-logo">
          <img [src]="logoSrc" alt="GardeKids" class="footer-logo-img" />
        </div>
        <p>{{ 'LANDING.FOOTER.DESC' | translate }}</p>
      </div>
      <div class="footer-links">
        <div class="footer-col">
          <h4>{{ 'LANDING.FOOTER.PLATFORM' | translate }}</h4>
          <a (click)="scrollTo('features')">{{ 'LANDING.NAV.FEATURES' | translate }}</a>
          <a (click)="scrollTo('how-it-works')">{{ 'LANDING.NAV.HOW_IT_WORKS' | translate }}</a>
          <a (click)="scrollTo('our-schools')">{{ 'LANDING.NAV.DIRECTORY' | translate }}</a>
          <a (click)="scrollTo('school-signup')">{{ 'LANDING.NAV.SCHOOLS' | translate }}</a>
          <a routerLink="/inscription">{{ 'LANDING.NAV.SUBSCRIBE' | translate }}</a>
        </div>
        <div class="footer-col">
          <h4>{{ 'LANDING.FOOTER.ACCESS' | translate }}</h4>
          <a routerLink="/authentication/signin">{{ 'LANDING.NAV.LOGIN' | translate }}</a>
          <a (click)="scrollTo('school-signup')">{{ 'LANDING.HERO.CTA_DEMO' | translate }}</a>
          <p class="footer-contact">contact&#64;gardekids.com</p>
          <p class="footer-contact">+216 71 000 000</p>
          <p class="footer-contact">Tunis, Tunisie</p>
          <div class="footer-social">
            <a href="https://www.facebook.com/" target="_blank" rel="noopener" aria-label="Facebook">
              <mat-icon>public</mat-icon>
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener" aria-label="Instagram">
              <mat-icon>photo_camera</mat-icon>
            </a>
            <a href="https://www.linkedin.com/" target="_blank" rel="noopener" aria-label="LinkedIn">
              <mat-icon>business</mat-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <span>&copy; {{ currentYear }} GardeKids. {{ 'LANDING.FOOTER.RIGHTS' | translate }}</span>
    </div>
  </div>
</footer>
